import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { undoLatest } from '../service/dimensionService'
import { getDimensionOptions } from './getDimensionOptions'
import useCreateQueryItem from '../../../services/api/hooks/useCreateQueryItem'
import { useUndoOptions } from './useUndoOptions'

export const useUndoLatest = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const dimensionOptions = getDimensionOptions(companyId)
  const undoOptions = useUndoOptions({ companyId })
  const { notification } = App.useApp()
  const createQueryItem = useCreateQueryItem()

  if (!companyId) {
    throw new Error('Company ID is required for dimensions.')
  }

  return useMutation({
    mutationKey: ['budget', 'dimension', 'undo'],
    mutationFn: () => undoLatest(companyId),
    onSuccess() {
      createQueryItem([dimensionOptions, undoOptions])
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
